import { render, staticRenderFns } from "./batchAttributes.vue?vue&type=template&id=534fbc2c&scoped=true"
import script from "./batchAttributes.vue?vue&type=script&lang=js"
export * from "./batchAttributes.vue?vue&type=script&lang=js"
import style0 from "./batchAttributes.vue?vue&type=style&index=0&id=534fbc2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534fbc2c",
  null
  
)

export default component.exports